// extracted by mini-css-extract-plugin
export var animationContainer = "_g0-0";
export var asteriskIcon = "_g0-8";
export var conversationLeftSection = "_g0-4";
export var conversationListItem = "_g0-3";
export var conversationMiddleSection = "_g0-5";
export var conversationRightSection = "_g0-6";
export var detailsContent = "_g0-1";
export var listContainer = "_g0-7";
export var modalContent = "_g0-2";